// extracted by mini-css-extract-plugin
export default {"home":"Home_home__CMw1J","search_form":"Home_search_form__1+mEg"};